const getServices = (facilities) => ({
  "@type": "OfferCatalog",
  name: "Services",
  itemListElement: facilities.map((facility) => ({
    "@type": "Offer",
    itemOffered: {
      "@type": "Service",
      name: facility
    }
  }))
});
export {
  getServices
};
//# sourceMappingURL=get-services.js.map
